import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";
// import HomeView from "../views/HomeView.vue";
import LoginView from "../views/Login.vue";
import { ElMessage } from "element-plus";
import { usePermissionStore } from "@/store/permissionStore";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: LoginView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/admin",
    name: "admin",
    component: () => import("../views/AdminView.vue"),
    meta: { title: "后台", requiresAuth: true },
    children: [
      {
        path: "dashboard",
        name: "dashboard",
        component: () => import("../views/DashboardView.vue"),
        meta: {
          title: "", requiresAuth: true, role: "dashboard",
          anyRoles: ["dashboard", "qc", "technicianLead:reportReview:list", "technicianLead:examinationFlow:list"],
        },
      },
      {
        path: "kanban",
        name: "case-kanban",
        component: () => import("../views/KanBan.vue"),
        meta: { title: "", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "case/list",
        name: "case-list",
        component: () => import("../views/CaseListView.vue"),
        meta: { title: "质控列表", requiresAuth: true, role: "qc:task" },
      },
      {
        path: "examinations/list",
        name: "examinations-list",
        component: () => import("../views/ExaminationsView.vue"),
        meta: { title: "抽样管理", requiresAuth: true, role: "qc:sample" },
      },
      // {
      //   path: "reporter/list",
      //   name: "reporter-list",
      //   component: () => import("../views/ReporterListView.vue"),
      //   meta: { title: "后台", requiresAuth: true },
      // },
      // rating
      {
        path: "rating/list",
        name: "rating-list",
        component: () => import("../views/RatingListView.vue"),
        meta: { title: "质控项目列表", requiresAuth: true, role: "option:projectItem:list" },
      },
      //rating detail
      {
        path: "rating/detail/:id",
        name: "rating-detail",
        component: () => import("../views/RatingDetailView.vue"),
        meta: { title: "评分规则详情", requiresAuth: true, role: "option:projectItem:list" },
      },
      {
        path: "critical/list",
        name: "critical-list",
        component: () => import("../views/CriticalValueList.vue"),
        meta: { title: "危急值管理", requiresAuth: true, role: "option:criticalValue" },
      },
      // users
      {
        path: "users",
        name: "user-list",
        component: () => import("../views/UserListView.vue"),
        meta: { title: "用户列表", requiresAuth: true, role: "system:user" },
      },
      //admin users roles
      {
        path: "user/role/list",
        name: "user-role-list",
        component: () => import("../views/AdminUserRoleListView.vue"),
        meta: { title: "用户角色管理", requiresAuth: true, role: "system:role:list" },
      },
      {
        path: "user/role/detail/:id",
        name: "user-role-detail",
        component: () => import("../views/AdminUserRoleDetailView.vue"),
        meta: { title: "编辑用户角色", requiresAuth: true, role: "system:role:edit" },
      },
      // {
      //   path: "user/roles",
      //   name: "user-role",
      //   component: () => import("../views/AdminUserRoleView.vue"),
      //   meta: { title: "后台", requiresAuth: true },
      // },
      {
        path: "roles",
        name: "role-list",
        component: () => import("../views/RoleListView.vue"),
        meta: { title: "医生角色列表", requiresAuth: true, role: "system:doctorRole" },
      },
      {
        path: "doctors",
        name: "doctor-list",
        component: () => import("../views/DoctorListView.vue"),
        meta: { title: "医生列表", requiresAuth: true, role: "system:doctor" },
      },
      {
        path: "dicts",
        name: "dict-list",
        component: () => import("../views/DictsListView.vue"),
        meta: { title: "常量管理", requiresAuth: true, role: "constant" },
      },
      {
        path: "statistics",
        name: "statistics-detail",
        component: () => import("../views/StatisticsView.vue"),
        meta: { title: "数据统计", requiresAuth: true, role: "statistics" },
      },
      {
        path: "statistics/items/detail",
        name: "statistics-items-detail",
        component: () => import("../views/StatisticsItemsDetailView.vue"),
        meta: { title: "数据统计详情", requiresAuth: true, role: "statistics:deduction" },
      },
      {
        path: "statistics/person",
        name: "statistics-person-detail",
        component: () => import("../views/StatisticsPersonView.vue"),
        meta: { title: "人员能力评估", requiresAuth: true, role: "statistics:assessment" },
      },
      {
        path: "statistics/critical",
        name: "statistics-critical-detail",
        component: () => import("../views/StatisticsCritalValueView.vue"),
        meta: { title: "危急值报告", requiresAuth: true, role: "statistics:critical" },
      },
      {
        path: "statistics/technician-lead",
        name: "technician-lead",
        component: () => import("../views/TechnicianLeadView.vue"),
        meta: {
          title: "技师长运营统计", requiresAuth: true,
          anyRoles: ["technicianLead:reportReview:list", "technicianLead:examinationFlow:list"],
        },
      },
      {
        path: "statistics/quality-report",
        name: "quality-report",
        component: () => import("../views/QualityReportView.vue"),
        meta: { title: "质控报告", requiresAuth: true, role: "statistics:assessment" },
      },
      {
        path: "settings/storage",
        name: "settings-storage",
        component: () => import("../views/SettingsStorageView.vue"),
        meta: { title: "存储策略管理", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "settings/configs",
        name: "settings-configs",
        component: () => import("../views/SettingsConfigs.vue"),
        meta: { title: "系统用户配置", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "settings/upload",
        name: "settings-upload",
        component: () => import("../views/DataUploadView.vue"),
        meta: { title: "数据上传", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "contrastmedia/catrgory",
        name: "contrastmedia-category-manage",
        component: () => import("../views/contrastmedia/CategoryManage.vue"),
        meta: { title: "对比剂类型管理", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "contrastmedia/reaction/category",
        name: "contrastmedia-reaction-manage",
        component: () => import("../views/contrastmedia/AdverseReactionsCategory.vue"),
        meta: { title: "对比剂不良反应分类", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "contrastmedia/reaction/record",
        name: "contrastmedia-reaction-record",
        component: () => import("../views/contrastmedia/AdverseReactionsRecord.vue"),
        meta: { title: "对比剂不良反应记录", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "contrastmedia/examinations/by-contrast-agent",
        name: "contrastmedia-examinations-by-contrast-agent",
        component: () => import("../views/contrastmedia/ContrastAgentPatients.vue"),
        meta: { title: "使用对比剂的患者数据", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "radiationsafety/doseratio",
        name: "radiationsafety-dose-ratio",
        component: () => import("../views/radiationsafety/DoseRatio.vue"),
        meta: { title: "放射剂量系数", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "radiationsafety/dosereference",
        name: "radiationsafety-dose-reference",
        component: () => import("../views/radiationsafety/DoseReference.vue"),
        meta: { title: "放射剂量参考值", requiresAuth: true, role: "system:storagePolicy" },
      },
      {
        path: "radiationsafety/dosereport",
        name: "radiationsafety-dose-report",
        component: () => import("../views/radiationsafety/DoseReport.vue"),
        meta: { title: "放射剂量报告", requiresAuth: true, role: "system:storagePolicy" },
      },
    ],
  },
  // 智能排班
  {
    path: "/schedule",
    name: "schedule",
    component: () => import("../views/AdminView.vue"),
    meta: { title: "智能排班", requiresAuth: true },
    children: [
      {
        path: "doctors",
        name: "schedule-doctors",
        component: () => import("../views/schedule/DoctorManage.vue"),
        meta: { title: "人员管理", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "roles",
        name: "schedule-roles",
        component: () => import("../views/schedule/RoleManage.vue"),
        meta: { title: "人员角色管理", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "home",
        name: "schedule-home",
        component: () => import("../views/schedule/index.vue"),
        meta: { title: "排班工作台", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "view",
        name: "schedule-view",
        component: () => import("../views/schedule/view.vue"),
        meta: { title: "排班预览", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "group",
        name: "schedule-group",
        component: () => import("../views/schedule/group.vue"),
        meta: { title: "分组管理", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "position",
        name: "schedule-position",
        component: () => import("../views/schedule/position.vue"),
        meta: { title: "岗位管理", requiresAuth: true, role: "qc:automatic" },
      },
      {
        path: "list",
        name: "schedule-list",
        component: () => import("../views/schedule/list.vue"),
        meta: { title: "我的排班", requiresAuth: true, role: "qc:automatic" },
      },
    ],
  },
  // case detail
  {
    path: "/admin/case/detail/:id/:eId",
    name: "case-detail",
    component: () => import("../views/CaseDetailView.vue"),
    meta: { title: "质控详情", requiresAuth: true, role: "qc:task" },
  },
  {
    path: "/admin/kanban/detail/:id",
    name: "case-kanban-detail",
    component: () => import("../views/KanBanDetailView.vue"),
    meta: { title: "", requiresAuth: true, role: "qc:automatic" },
  },
  {
    path: "/person-quality-report",
    name: "person-quality-report",
    component: () => import("../views/PersonQualityReportView.vue"),
    meta: { title: "人员质控报告", requiresAuth: true, role: "statistics:assessment" },
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem("token");
  const ttl = localStorage.getItem("ttl");
  const now = new Date().getTime();
  //如果是超管，直接放行
  if (usePermissionStore().$state.superAdmin) {
    next();
  } else {
    // 如果页面需要权限
    if (to.meta.requiresAuth) {
      // 如果没有 token 或者 token 过期
      if (!token || !ttl || now > parseInt(ttl)) {
        ElMessage.error("请先登录");
        next({ path: "/" });
        return;
      }
      // if (store.getters.hasPermission(to.meta.role)) {

      const anyRoles = to.meta.anyRoles as string[] | undefined;
      if (anyRoles ? anyRoles.some(code => usePermissionStore().hasPermission(code)) : usePermissionStore().hasPermission(to.meta.role)) {
        next();
      } else {
        ElMessage.error("您没有权限访问该页面");
        next({ path: "/" });
      }
    } else {
      next();
    }
  }
});

export default router;
